angular.module('leanlaw').directive('invoiceFilterState', [function () {
  return {
    restrict: 'A',
    scope: {
      filter: '=ngModel',
      readonly: '&',
      hideScope: '=filterStateHideScope',
      hideClientMatter: '=filterStateHideClientMatter'
    },
    template: require('./views/filterState.html'),
    controller: 'InvoiceFilterStateController'
  };
}]).controller('InvoiceFilterStateController', ['$scope', 'userService', function ($scope, userService) {
  userService.me().then(me => {
    $scope.me = me;
  });
  $scope.resetBilled = function () {
    $scope.filter.billed = null;
  };
  $scope.resetScope = function () {
    $scope.filter.scopeAccount = null;
    $scope.filter.scope = 'all';
  };
  $scope.resetRange = function () {
    $scope.filter.range = {};
  };
  $scope.resetClient = function () {
    $scope.filter.client = null;
    $scope.filter.matter = null;
  };
}]);